module.exports = __webpack_public_path__ + "img/energy_jienengzengxiaoyouhua.aee5b2d5.png";